// extracted by mini-css-extract-plugin
export var columns = "article-content-columns-module--columns--44839";
export var contentContainer = "article-content-columns-module--content-container--c5661";
export var section = "article-content-columns-module--section--b69e6";